import Endorsement from "@higher/models/Endorsement";
import { stateSubscriptionById } from "./stateSubscriptionById";

const EndorsementsCollection = "endorsements";

export default stateSubscriptionById<Endorsement>(
  "EndorsementById",
  EndorsementsCollection
);
